import { render, staticRenderFns } from "./create_template.vue?vue&type=template&id=87628b74&scoped=true&"
import script from "./create_template.vue?vue&type=script&lang=js&"
export * from "./create_template.vue?vue&type=script&lang=js&"
import style0 from "./create_template.vue?vue&type=style&index=0&id=87628b74&scoped=true&lang=css&"
import style1 from "./create_template.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87628b74",
  null
  
)

export default component.exports